import { ReportInput } from '../../types';
import { ReportState } from '../state';

export const setInput = (state: ReportState, payload: ReportInput) => {
  state.inputs = payload;
};
